import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alpine_linux",
  "use": "alpine_linux-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"alpine_linux\"><path d=\"M13.04 2H4.96L.92 9l4.04 7h8.08l4.04-7zm-6.41 8.78c-.44-.02-.84-.21-1.13-.5l1.13-1.1zm3.32-.49L7.52 7.93l-2.44 2.36c-.62.6-1.61.6-2.23 0l4.67-4.52 4.67 4.52c-.62.6-1.61.6-2.24 0m2.85.04-2.02-1.96-.17.17-1.13-1.08 1.29-1.25 4.26 4.12c-.62.61-1.61.61-2.23 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol